export default Object.freeze({
  NCP_NOTICE: 'NCP 공지사항',
  NOTICE_CATEGORY: '공지사항 카테고리',
  SEARCH_WORD: '검색어',
  NOTICE: '공지사항',
  ATTACHMENTS: '첨부파일',
});
